// components/ContactFloatIcons.jsx
import React from 'react';
import '../style.css';

const WhatsAppCallIcons = () => {
  const whatsappNumber = "+91 80903 11155";
  const callNumber = "+91 80903 11155";
  const message = "Hello, I need information about RocklandClinic Hospital";

  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
  const callUrl = `tel:${callNumber}`;

  return (
    <div className="simple-contact-icons">
      {/* WhatsApp Icon */}
      <a 
        href={whatsappUrl}
        className="simple-icon whatsapp-btn"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Message on WhatsApp"
      >
        <img 
          src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" 
          alt="WhatsApp"
          className="icon-img"
        />
      </a>

      {/* Call Icon */}
      <a 
        href={callUrl}
        className="simple-icon call-btn"
        aria-label="Call Hospital"
      >
        <img 
          src="https://cdn-icons-png.flaticon.com/512/126/126341.png" 
          alt="Call"
          className="icon-img"
        />
      </a>
    </div>
  );
};

export default WhatsAppCallIcons;